import qs from 'qs';
import mapValues from 'lodash/fp/mapValues';
import forEach from 'lodash/fp/forEach';
import get from 'lodash/fp/get';
import { storage } from './storageUtils';
export const DEFAULT_PREFIX = 'featureToggle.';
export const cleanupOldToggles = (oldToggles, prefix) => {
    try {
        forEach(toggle => storage.removeItem(toggle, prefix), oldToggles);
    }
    catch (error) {
        console.error(error);
    }
};
const detectToggle = (param, prefix, transformFn, defaultValue) => {
    const [_, searchParams = ''] = window.location.hash.split('?');
    const urlSearchParams = qs.parse(searchParams);
    const urlValue = get(param, urlSearchParams)?.toString() || '';
    const storageValue = urlValue ? storage.save(param, urlValue, prefix) : storage.load(param, prefix);
    return storageValue ? transformFn(storageValue) : defaultValue;
};
const transformBoolean = (value) => value === 'true' || value === '1';
const transformString = (value) => value;
const transformNumber = (value) => Number.parseFloat(value);
export const asBoolean = (urlParamName) => (prefix) => detectToggle(urlParamName, prefix, transformBoolean, null);
export const asBooleanWithDefault = (urlParamName, defaultValue) => (prefix) => detectToggle(urlParamName, prefix, transformBoolean, defaultValue);
export const asString = (urlParamName) => (prefix) => detectToggle(urlParamName, prefix, transformString, null);
export const asStringWithDefault = (urlParamName, defaultValue) => (prefix) => detectToggle(urlParamName, prefix, transformString, defaultValue);
export const asNumber = (urlParamName) => (prefix) => detectToggle(urlParamName, prefix, transformNumber, null);
export const asNumberWithDefault = (urlParamName, defaultValue) => (prefix) => detectToggle(urlParamName, prefix, transformNumber, defaultValue);
export const detectFeatureToggles = (toggleDefinitions, oldToggles = [], prefix = DEFAULT_PREFIX) => {
    cleanupOldToggles(oldToggles, prefix);
    return mapValues(toggleFn => toggleFn(prefix), toggleDefinitions);
};
